import React, { useEffect, Fragment, useState, useRef } from "react";
import Breadcrumb from "../../../../components/common/breadcrumb";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useForm } from "react-hook-form";
import { showToast } from "../../../../components/ToastifyNotification";
import { UncontrolledTooltip } from "reactstrap";
import { GetRoomCategories } from "../../../../api/ipd/roomCategoryAPI";
import { GetRoomById, UpdateRoom } from "../../../../api/ipd/roomAPI";
import { GetNursingStations } from "../../../../api/ipd/nursingStationAPI";
import {
  GetMedicineGroupById,
  UpdateMedicineGroup
} from "../../../../api/medicalStore/master/medicineGroupAPI";
import useKeyboardSubmit from "../../../../hooks/useKeyboardSubmit";
import useEnterNavigation from "../../../../hooks/useEnterNavigation";

// Validation schema using Yup
const schema = yup.object().shape({
  name: yup.string().required("Medicine Group name is required"),
  discountPercentage: yup
    .number()
    .typeError("Discount must be a number")
    .min(0, "Discount cannot be less than 0")
    .max(100, "Discount cannot be more than 100")
    .required("Discount percentage is required")
});

const EditMedicineGroup = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { id } = useParams();

  const { register, handleSubmit, setValue, formState: { errors } } = useForm({
    resolver: yupResolver(schema)
  });

  const fetchData = async () => {
    try {
      const response = await GetMedicineGroupById(id); // Make sure login function returns token

      if (response.success) {
        Object.keys(response.data).forEach(key => {
          setValue(key, response.data[key]);
        });
      } else {
        // setError(response.message);
        showToast("error", response.message);
      }
    } catch (error) {
      // setError(error); // Handle login errors
      showToast("error", error);
    }
  };

  // Fetch existing data
  useEffect(
    () => {
      if (id) {
        fetchData();
      }
    },
    [id, setValue]
  );

  const onSubmit = async data => {
    try {
      dispatch({ type: "LOADER_START" });

      const response = await UpdateMedicineGroup(id, data);
      if (response.success) {
        showToast("success", response.message);
      } else {
        showToast("error", response.message);
      }
    } catch (error) {
      showToast("error", error);
    } finally {
      dispatch({ type: "LOADER_STOP" });
    }
  };

  const formRef = useRef(null);
  useKeyboardSubmit(handleSubmit, onSubmit);
  useEnterNavigation(formRef);

  return (
    <Fragment>
      <Breadcrumb parent="Medical Store" title="Edit Medicine Group" />

      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-12">
            <div className="card">
              {/* ===== HEADER ===== */}
              <div className="card-header">
                <div className="d-flex justify-content-between">
                  <h5>Edit Medicine Group</h5>
                  <Link to={`/medical-store/master/medicine-group/list`}>
                    <button className="btn btn-primary" id="list">
                      List Medicine Groups
                    </button>
                    <UncontrolledTooltip placement="top" target="list">
                      List Medicine Groups
                    </UncontrolledTooltip>
                  </Link>
                </div>
              </div>

              {/* ===== FORM ===== */}
              <form
                ref={formRef}
                className="form theme-form"
                onSubmit={handleSubmit(onSubmit)}
              >
                <div className="card-body">
                  <div className="row">
                    {/* Medicine Group Name */}
                    <div className="col-6">
                      <div className="form-group">
                        <label>Medicine Group Name</label>
                        <input
                          className="form-control"
                          type="text"
                          placeholder="Enter Medicine Group Name"
                          {...register("name")}
                        />
                        {errors.name &&
                          <p className="text-danger">
                            {errors.name.message}
                          </p>}
                      </div>
                    </div>

                    {/* Discount Percentage */}
                    <div className="col-6">
                      <div className="form-group">
                        <label>Discount Percentage (%)</label>
                        <input
                          className="form-control"
                          type="number"
                          placeholder="Enter Discount Percentage"
                          {...register("discountPercentage")}
                        />
                        {errors.discountPercentage &&
                          <p className="text-danger">
                            {errors.discountPercentage.message}
                          </p>}
                      </div>
                    </div>
                  </div>
                </div>

                {/* ===== FOOTER ===== */}
                <div className="card-footer text-end">
                  <button className="btn btn-primary" type="submit">
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default EditMedicineGroup;
